import { EGlobalAppActions, AppActions } from 'src/app/store/actions/app.actions';
import { IGlobalConfigState, initialGlobalConfigState } from 'src/app/store/state/globalconfig.state';

export function GlobalConfigReducers (
    state = initialGlobalConfigState,
    action: AppActions
): IGlobalConfigState{
    switch (action.type) {
        case EGlobalAppActions.GetAppWaiting: {
            return { ...state };
        }
        case EGlobalAppActions.GetLoggedUser: { return { ...state }; }
        case EGlobalAppActions.SetAppWaiting: { return { ...state, isWaiting: action.payload }; }
        case EGlobalAppActions.SetUser: { return { ...state, user: action.payload }; }
        default: return state;
    }
};
